import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_edi_delete_wavelength_transmissionsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { entity: string, id: number, transaction_id?: string, transmission_type: string, transmission_direction: string }): Promise<{ success?: boolean, messages?: string[], transmission_id?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.entity)) {
      $missingRequiredInParams.push('\'entity\'');
    }
    if (isNil($inParams.id)) {
      $missingRequiredInParams.push('\'id\'');
    }
    if (isNil($inParams.transmission_type)) {
      $missingRequiredInParams.push('\'transmission_type\'');
    }
    if (isNil($inParams.transmission_direction)) {
      $missingRequiredInParams.push('\'transmission_direction\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/app/functions/edi_delete_wavelength_transmissions`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

